import { type FC } from 'react';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import routes from '@shared/routes';
import { Flex } from '@shared/ui-kit';

import { LinkStyled } from './_styled';

const AppNavigation: FC = () => {
  const t = useTranslations();
  const pathname = usePathname();

  return (
    <Flex
      className="no-print"
      columnGap="4"
    >
      <LinkStyled
        isActive={routes.merchants === pathname}
        href={routes.merchants}
        scroll
      >
        {t('MerchantsPage.title')}
      </LinkStyled>
      <LinkStyled
        isActive={routes.marketplaces === pathname}
        href={routes.marketplaces}
        scroll
      >
        {t('MarketplacesPage.title')}
      </LinkStyled>
      <LinkStyled
        isActive={routes.import === pathname}
        href={routes.import}
      >
        {t('ImportPage.linkTitle')}
      </LinkStyled>
      <LinkStyled
        isActive={pathname.includes(routes.management)}
        href={routes.management}
      >
        {t('General.settings')}
      </LinkStyled>
    </Flex>
  );
};

export default AppNavigation;
